  $(document).ready(function() {
    $('.fancybox').each(function(){
      if($(this).data('videothumb'))
        $(this).data('thumb', $(this).data('videothumb'));
      else
        $(this).data('thumb', $(this).attr('href'));
    });

    $('.fancybox').fancybox({
      animationEffect : "fade",
      'afterClose':function() {
        $('.header-container').show();
      },
      /*
      afterShow : function( instance, current ) {
        current.opts.$orig.closest('.slick-initialized').slick('slickGoTo', parseInt(current.index), true);
      },
      */
      'beforeShow':function(instance, current) {
        instance.current.opts.caption = $(instance.current.opts.$orig[0]).attr('title');
      },
        thumbs: {
        autoStart: true, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: ".fancybox-container", // Container is injected into this element
        axis: "y" // Vertical (y) or horizontal (x) scrolling
      }
  });

  $('.fancybox').on('click', function(event) {
    $('.header-container').hide();
  });
  
  // move the following to a special video tracking js
  // TODO: traking besser machen im rahmen von FS#23324 - TO+RP: Video Tracking anlegen und Seiten verbessern
  $('.slide-showvideo, .slide-showvideo-button, .mobile-landing .video .play, .first-container .video')
    .on('click', function() {
      // $('#slider').easySliderStop();
    })
    .fancybox({
      width       : 960, 
      height      : 540,
      openEffect  : 'none',
      closeEffect : 'none',
      afterLoad   : function() {
       pSendGAEvent('pt_video_click', {'pt_video_id': 'explanation'}, 'fancybox-custom.js', 'Video send event gone wrong'); 
      },
      media : {
        youtube : {
          params : {
            autoplay : 0
          }
        }
      }
    });
  
  $('.videoBlock .playicon.lightbox')
    .on('click', function() {
      // $('#slider').easySliderStop();
    })
    .fancybox({
      openEffect  : 'none',
      closeEffect : 'none',
      afterLoad   : function() {
       pSendGAEvent('pt_video_click', {'pt_video_id': $(this).data('pt_video_id')}, 'fancybox-custom.js', 'Video send event gone wrong'); 
      },
      media : {
        youtube : {
          params : {
            autoplay : 0
          }
        }
      }
    });
  
  
  // --- ... until here ----
  
  
  if (window.location.href.indexOf('#video')>0) {
    // show the video by triggering a click on the first fancybox button - to trigger click-handlers registered for stopping easySlider
    //$(".slide-showvideo-button").eq(0).trigger('click');
    $(".first-container .video").eq(0).trigger('click');
  }
  
});